import React from 'react';
import { Stack } from '@fluentui/react';
import clsx from 'clsx';

import { IDialogCardFooterProps } from './DialogCard.Props';
import { useDialogCardFooterStyles } from './DialogCardFooter.styles';

export const DialogCardFooter = (props: IDialogCardFooterProps) => {
  const {
    className,
    children,
    hasFooterBackground = true,
    horizontal = false,
    horizontalAlign = 'center',
    sticky = true,
    tokens,
    wrap = false,
  } = props;

  const styles = useDialogCardFooterStyles(hasFooterBackground, sticky);

  if (!children) {
    return null;
  }

  return (
    <Stack
      className={clsx(className, styles.footer)}
      horizontal={horizontal}
      horizontalAlign={horizontalAlign}
      wrap={wrap}
      tokens={tokens}
    >
      {children}
    </Stack>
  );
};
